<!--
 * @Description: 
 * @Version: 2.0
 * @Autor: 胡彩丽 hucaili@qfei.cn
 * @LastEditors: 胡彩丽 hucaili@qfei.cn
-->
<template>
  <jw-space wrap>
    <jw-checkbox v-if="isCheckAll" :model-value="checkedAll" :indeterminate="indeterminate" @change="handleChangeAll">全选</jw-checkbox>
    <jw-checkbox-group class="xl-search-group" v-model="selectVal" :default-value="defVal" @change="changeSelect">
      <template v-if="subcol.card">
        <jw-checkbox :value="item[dataProps.value]" v-for="item in options" :key="item[dataProps.value]" :class="{ 'item-isEnabled': !item.isEnabled }">
          <template #checkbox="{ checked }">
            <jw-space class="jw-custom-card" :class="{ 'jw-custom-card-checked': checked }">
              <template v-if="item?.icon">
                <component :is="item?.icon" />
              </template>
              <template v-else-if="item?.pic">
                <img class="jw-custom-card-pic" :src="item?.pic" />
              </template>
              {{ item[dataProps.label] }}
            </jw-space>
          </template>
        </jw-checkbox>
      </template>
      <template v-else>
        <jw-checkbox :value="item[dataProps.value]" v-for="item in options" :key="item[dataProps.value]" :class="{ 'item-isEnabled': !item.isEnabled }">{{ item[dataProps.label] }}</jw-checkbox>
      </template>
    </jw-checkbox-group>
  </jw-space>
</template>

<script setup>
// import { reactive, toRefs } from 'vue';
import { ref, computed, watchEffect, onMounted } from 'vue';
const props = defineProps({
  subcol: {
    type: Object,
    default() {
      return {};
    }
  }
});

const emits = defineEmits(['cb']);
// 增加全选
const indeterminate = ref(false);
const checkedAll = ref(false);

const selectVal = ref(props.subcol.value || []);
const defVal = computed(() => props.subcol.value || []);
const isCheckAll = computed(() => props.subcol.checkAll || false);
const dataProps = computed(() => props.subcol.dataProps || { label: 'label', value: 'value' });
const options = ref(props.subcol.data || []);

watchEffect(() => {
  options.value = props.subcol.data || [];
  selectVal.value = props.subcol.value;
});

// 全选 半选 事件
const checkEvent = () => {
  // 半选
  indeterminate.value = !!(selectVal.value?.length && options.value?.length !== selectVal.value?.length);
  // 反选
  checkedAll.value = options.value?.length === selectVal.value?.length;
};
// select 事件
const changeSelect = (v) => {
  const o = {};
  console.log(33, v);
  let pv = v;
  if (pv.length === 0) pv = undefined;
  o[props.subcol.name] = pv;
  checkEvent();
  emits('cb', o);
};

// 处理全选事件
const handleChangeAll = (value) => {
  indeterminate.value = false;
  if (value) {
    checkedAll.value = true;
    selectVal.value = options.value.map((el) => el[dataProps.value.value]);
  } else {
    checkedAll.value = false;
    selectVal.value = [];
  }
  changeSelect(selectVal.value);
};

onMounted(() => {
  checkEvent();
});
</script>
<style scoped lang="less">
@import './xl-checkbox.less';
</style>
